<template>
  <div class="page --grey-bg contatti-prodotto">
    <FormContactProduct :product="product" />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'
import { useHelpers } from '~/composables/helpers.js'

const { configuration } = useStore()

// Fetch Data
const query = queries.contatti.getContactsProduct
const route = useRoute()

const variables = computed(() => ({
  site: 'it',
  slug: route.params.product,
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.entry) {
  throw createError({ statusCode: 404 })
}

const { locale } = useI18n()

const getLocalizedField = (field) => {
  switch (locale.value) {
    case 'en':
      return data.value.entry[`${field}En`]
    case 'es':
      return data.value.entry[`${field}Es`]
    case 'fr':
      return data.value.entry[`${field}Fr`]
    default:
      return data.value.entry[field]
  }
}

const stripHtmlTags = (str) => {
  if (!str) return ''
  const withoutTags = str.replace(/<\/?[^>]+(>|$)/g, '')
  const firstSentence = withoutTags.split('.')[0]
  return firstSentence + '.'
}

const product = computed(() => data.value.entry)
const seo = computed(() => data.value?.entry?.seo || {})

const localeParams = computed(() => data.value?.entry?.localized || [])

// Seo
useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'product'),
  meta: [
    {
      name: 'description',
      content: stripHtmlTags(getLocalizedField('descrizioneProdotto')),
    },
  ],
})
</script>
